import React from "react";
import { FaEnvelope, FaLock, FaPhone, FaSearch } from "react-icons/fa";
import { MdOutlineRocketLaunch } from "react-icons/md";

import SocialLinks from "./SocialLinks";
import NavbarAccountMenu from "./NavbarAccountMenu";

function ActionPill({ icon: Icon, label, href, onClick, title, variant = "dark" }) {
  const baseClass =
    "group relative hidden min-h-11 items-center gap-2 overflow-hidden rounded-[1.35rem] px-4 py-2 text-sm font-bold transition duration-300 hover:-translate-y-0.5 xl:inline-flex";

  const variants = {
    dark:
      "border border-white/10 bg-white/10 text-white shadow-lg shadow-black/10 hover:bg-white/15",
    blue:
      "bg-gradient-to-r from-sky-500 to-blue-600 text-white shadow-lg shadow-sky-950/25 hover:from-sky-400 hover:to-blue-500",
  };

  const content = (
    <>
      <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/20 to-transparent transition duration-700 group-hover:translate-x-full" />

      <span className="relative flex h-7 w-7 items-center justify-center rounded-xl bg-white/15">
        <Icon className="h-3.5 w-3.5" />
      </span>

      <span className="relative whitespace-nowrap">{label}</span>
    </>
  );

  if (href) {
    return (
      <a href={href} title={title} className={`${baseClass} ${variants[variant]}`}>
        {content}
      </a>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className={`${baseClass} ${variants[variant]}`}
    >
      {content}
    </button>
  );
}

export default function NavbarActions({
  isDemo,
  socialLinks,
  contactInfo,
  effectiveUser,
  permissionsLoaded,
  initials,
  brandBg,
  accountRef,
  accountOpen,
  setAccountOpen,
  onNavigate,
  onAdminAccess,
  onLogout,
  onSearchClick,
}) {
  return (
    <div className="flex shrink-0 items-center gap-2 pr-2 sm:gap-3">
      {isDemo && (
        <ActionPill
          icon={MdOutlineRocketLaunch}
          label="MonAppliMairie"
          onClick={() => onNavigate("/monapplimairie")}
          variant="blue"
        />
      )}

      <SocialLinks links={socialLinks} />

      {contactInfo?.email && (
        <ActionPill
          icon={FaEnvelope}
          label="Mail"
          href={`mailto:${contactInfo.email}`}
          title={contactInfo.email}
        />
      )}

      {contactInfo?.phone && (
        <ActionPill
          icon={FaPhone}
          label="Appeler"
          href={`tel:${contactInfo.phone}`}
          title={contactInfo.phone}
        />
      )}

      {!effectiveUser ? (
        <>
          <button
            type="button"
            onClick={() => onNavigate("/login")}
            aria-label="Accès administration"
            className="group relative hidden min-h-11 items-center gap-2 overflow-hidden rounded-[1.35rem] border border-white/10 bg-white/10 px-4 py-2 text-sm font-bold text-white transition duration-300 hover:-translate-y-0.5 hover:bg-white/15 md:inline-flex"
          >
            <span className="flex h-7 w-7 items-center justify-center rounded-xl bg-white/15">
              <FaLock className="h-3.5 w-3.5" />
            </span>
            Administration
          </button>

          <button
            type="button"
            onClick={() => onNavigate("/login")}
            aria-label="Accès administration"
            className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-white/10 transition hover:bg-white/20 md:hidden"
          >
            <FaLock className="h-4 w-4" />
          </button>
        </>
      ) : (
        <NavbarAccountMenu
          effectiveUser={effectiveUser}
          permissionsLoaded={permissionsLoaded}
          initials={initials}
          brandBg={brandBg}
          accountRef={accountRef}
          accountOpen={accountOpen}
          setAccountOpen={setAccountOpen}
          onAdminAccess={onAdminAccess}
          onLogout={onLogout}
        />
      )}

      <button
        type="button"
        onClick={onSearchClick}
        aria-label="Rechercher"
        className="group relative flex h-14 min-w-12 flex-col items-center justify-center gap-1 overflow-hidden rounded-2xl px-3 transition hover:bg-white/10"
      >
        <span className="absolute inset-0 opacity-0 transition group-hover:opacity-100">
          <span className="absolute left-1/2 top-1/2 h-10 w-10 -translate-x-1/2 -translate-y-1/2 rounded-full bg-sky-400/20 blur-xl" />
        </span>

        <FaSearch className="relative h-5 w-5" />

        <span className="relative hidden text-[11px] font-bold tracking-wider sm:inline">
          RECHERCHE
        </span>
      </button>
    </div>
  );
}